type Constructor<T={}> = abstract new (...args: any[]) => T

// TODO: Figure out why TS can't handle unique symbols in mixins
//
// https://github.com/microsoft/TypeScript/issues/17293
// https://github.com/microsoft/TypeScript/issues/17744#issuecomment-431534647
// https://github.com/microsoft/TypeScript/issues/30355
// https://github.com/microsoft/TypeScript/issues/36060
callbacks: unique symbol := Symbol "eventCallbacks"

{ remove } from ./util.civet

// HACK: this is to workaround 'extends' clause of exported class '...' has or is using private name 'callbacks'.typescript(4020)
// that pops up when extending from Bindable(Object), etc.
export type BindableClass = abstract new (...args: any[]) => BindableInstance

interface BindableInstance
  on(event: string, callback: Function): this
  off(event: string, callback?: Function): this
  trigger(event: string, ...parameters: any[]): this

export Bindable := <Base extends Constructor<{}>>(S: Base): Base & BindableClass ->
  abstract class Bindable extends S
    [callbacks]: Record<string, Function[]> = {}

    @(...args: any[])
      super(...args)

    on(event: string, callback: Function)
      @[callbacks][event] ||= []
      @[callbacks][event].push(callback)

      return this

    off(event: string, callback?: Function)
      if event
        @[callbacks][event] ||= []

        if callback
          remove @[callbacks][event], callback
        else
          @[callbacks][event] = []

      return this

    trigger(event: string, parameters...: any[])
      (@[callbacks]["*"] or []).forEach (callback) =>
        callback.apply(@, [event].concat(parameters))

      unless event is "*"
        (@[callbacks][event] or []).forEach (callback) =>
          callback.apply(@, parameters)

      return this

  return Bindable

export default Bindable
